import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Card,
  Form,
  Select,
  Col,
  Divider,
  Spin,
  DatePicker,
  Button,
  Typography,
} from "antd";

//ANT DESIGN ICONS IMPORT
import { LeftOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";

const { TextArea } = Input;

const UndoApprovalRecurringDepositAcc = (props) => {
  const { TextArea } = Input;
  const { userData } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  function onCancel() {
    navigate("/detail-recurring-deposit-account", { state: state });
  }
  const onSubmit = (formValues) => {
    const url = `${apiConfig.Recurringdepositaccounts}/${state.id}`;
    const params = {
      command: "undoapproval",
    };
    formValues.note = formValues.note;

    const body = {
      ...formValues,
      // dateFormat: "dd MMMM yyyy",
      // locale: "en",
      method: "POST",
      session,
      params,
    };
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(
            cnt.SUCCESS,
            labelConfig.undoApprovalRecurringDepositAccMsg
          );
          navigate("/detail-recurring-deposit-account", {
            state: { ...state, statusValue: accountStatus.submittedAndPending },
          });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-recurring-deposit-account", {
            state: { ...state, statusValue: accountStatus.submittedAndPending },
          });
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent
        pageTitle={labelConfig.undoApprovalRecurringDepositAcc}
        pageItems={staticConfig.recurringDepositAccUndoApprovalBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.note} name="note">
                  <TextArea
                    autoSize={{
                      minRows: 2,
                      maxRows: 6,
                    }}
                    placeholder="Please enter a note"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default UndoApprovalRecurringDepositAcc;
